import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import InputMask from "react-input-mask";
import MenuPrinc from "../../Componentes/MenuPrinc";
import { Container, HomeFornada } from "./styles";
import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBContainer,
  MDBInputGroup,
  MDBBtn,
  MDBDataTable,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// import PtBr from 'date-fns/locale/pt-BR';
import {
  MudaVisibilidade,
  alternaClasse,
  trocaAbas,
} from "../../services/funcoes";
import { URLBunge } from "../../Componentes/Config";
import Carregando from "../../Componentes/Carregando";
import HeaderPortalVendedor from "../HeaderPortalVendedor";

var ListaLojas = {
  columns: [
    {
      label: "CODIGO",
      field: "codigo",
      sort: "asc",
      width: 100,
    },
    {
      label: "CNPJ",
      field: "cnpj",
      sort: "asc",
      width: 100,
    },
    {
      label: "Razão Social",
      field: "nome",
      sort: "asc",
      width: 100,
    },
    {
      label: "Email Loja",
      field: "email",
      sort: "asc",
      width: 100,
    },
    {
      label: "Potencial",
      field: "potencial",
      sort: "asc",
      width: 100,
    },
    {
      label: "Faixa",
      field: "faixa",
      sort: "asc",
      width: 100,
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
      width: 100,
    },
    {
      label: "Frequencia",
      field: "metaFrequencia",
      sort: "asc",
      width: 100,
    },
    {
      label: "DDD",
      field: "dddLoja",
      sort: "asc",
      width: 100,
    },
    {
      label: "Telefone Loja",
      field: "telefoneLoja",
      sort: "asc",
      width: 100,
    },
    {
      label: "Cep",
      field: "cep",
      sort: "asc",
      width: 100,
    },
    {
      label: "Endereço",
      field: "rua",
      sort: "asc",
      width: 100,
    },
    {
      label: "Cidade/UF",
      field: "cidade",
      sort: "asc",
      width: 100,
    },
    {
      label: "Editar",
      field: "editar",
      sort: "asc",
      width: 100,
    },
  ],
  rows: [],
};

const TOKEN = localStorage.getItem("c_token");
const EMAIL_USUARIO = localStorage.getItem("c_email");
class VendedorLojas extends Component {
  state = {
    pushLojas: {
      codigo: "",
      cnpj: "",
      status: "",
      statusId: "",
      nome: "",
      dddLoja: "",
      telefoneLoja: "",
      email: "",
      potencial: "",
      faixa: "",
      metaFrequencia: "",
      cep: "",
      rua: "",
      ruaNumero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      estado: "",
      Readonly: true,
      vendedorId: 0,
    },
    att: false,
    codigo: "",
    cnpj: "",
    status: "",
    statusId: "",
    nome: "",
    dddLoja: "",
    telefoneLoja: "",
    email: "",
    potencial: "",
    faixa: "",
    metaFrequencia: "",
    cep: "",
    rua: "",
    ruaNumero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    intervalId: 0,
    DadosLoja: {},
    Readonly: false,
    vendedorId: 0,
    vendedoresTotal: [],
    disabled: "",
    loading: false,
  };

  async componentDidMount() {
    this.CarregaVendedores();
  }

  toggle = (nr, push) => {
    if (push != null) {
      this.setState({ pushLojas: push });
      this.setState({ disabled: "disabled" });
    } else {
      this.setState({
        pushLojas: {
          codigo: "",
          cnpj: "",
          status: "",
          statusId: "",
          nome: "",
          dddLoja: "",
          telefoneLoja: "",
          email: "",
          potencial: "",
          faixa: "",
          metaFrequencia: "",
          cep: "",
          rua: "",
          ruaNumero: "",
          complemento: "",
          bairro: "",
          cidade: "",
          estado: "",
          Readonly: false,
          vendedorId: 0,
        },
      });
      this.setState({ disabled: "" });
    }

    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  CarregaVendedores = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const retornoVendedores = await fetch(
      `${URLBunge}/api/Vendedores/ListaVendedores`,
      requestOptions
    ).then((response) => response.json());

    if (retornoVendedores.sucesso) {
      this.setState({ vendedores: {} });
      var vendedoresTotal = [];
      await retornoVendedores.usuarios.map((user) => {
        return user.departamentoId == 10 ? vendedoresTotal.push(user) : "";
      });
      await this.setState({ vendedoresTotal });
    }
  };

  CarregaLojas = async () => {
    this.setState({ loading: true });
    var cnpj = this.state.cnpj.replace(".", "");
    cnpj = cnpj.replace(".", "");
    cnpj = cnpj.replace("/", "");
    cnpj = cnpj.replace("-", "");

    if (cnpj != "" && cnpj.length < 14) {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o CNPJ correto!",
      });
      this.setState({ loading: false });
      return;
    }

    var dados = {
      cnpj: cnpj,
      codigoLoja: this.state.codigo,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      body: JSON.stringify(dados),
      headers: myHeaders,
      redirect: "follow",
    };
    var lojas = await fetch(
      `${URLBunge}/api/Vendedores/ListaLojas/`,
      requestOptions
    ).then((response) => response.json());

    var linhas = ListaLojas;
    linhas.rows = [];

    if (lojas.sucesso) {
      this.setState({ DadosLoja: {} });

      await lojas.lista.forEach(async (store) => {
        linhas.rows.push({
          codigo: store.codigo,
          cnpj: store.cnpj,
          nome: store.nome,
          email: store.email,
          potencial: store.potencial,
          faixa: store.faixa,
          status: store.status,
          metaFrequencia: store.metaFrequencia,
          dddLoja: store.dddLoja,
          telefoneLoja: store.telefoneLoja,
          cep: store.cep,
          rua: store.rua + "/" + store.enderecoNumero,
          cidade: store.cidade + "/" + store.estado,
          editar: (
            <MDBBtn
              color="blue"
              size="sm"
              onClick={() => this.toggle(4, store)}
            >
              Editar
            </MDBBtn>
          ),
        });
      });

      this.setState({ DadosLoja: linhas });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: lojas.mensagem,
      });
    }

    this.setState({ loading: false });
  };

  CadastrarLojas = async () => {
    this.setState({ loading: true });
    //var dataCad = new FormData();
    if (this.state.pushLojas.codigo == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o Código",
      });
      this.setState({ loading: false });
      return;
    }
    if (this.state.pushLojas.cnpj == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o Cnpj",
      });
      this.setState({ loading: false });
      return;
    }
    if (this.state.pushLojas.nome == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe a Razão Social",
      });
      this.setState({ loading: false });
      return;
    }
    if (this.state.pushLojas.potencial == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o Potencial",
      });
      this.setState({ loading: false });
      return;
    }
    if (this.state.pushLojas.faixa == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe a faixa",
      });
      this.setState({ loading: false });
      return;
    }
    if (this.state.pushLojas.metaFrequencia == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe a Meta Frequencia",
      });
      this.setState({ loading: false });
      return;
    }
    if (this.state.pushLojas.statusId == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o status",
      });
      this.setState({ loading: false });
      return;
    } else if (this.state.pushLojas.vendedorId == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o Vendedor",
      });
      this.setState({ loading: false });
      return;
    }

    var cnpj = this.state.pushLojas.cnpj.replace(".", "");
    cnpj = cnpj.replace(".", "");
    cnpj = cnpj.replace("/", "");
    cnpj = cnpj.replace("-", "");

    var dados = {
      /* "idProjeto": getProjeto(), */
      cnpj: cnpj,
      codigo: this.state.pushLojas.codigo,
      potencial: this.state.pushLojas.potencial,
      faixa: this.state.pushLojas.faixa,
      metaFrequencia: this.state.pushLojas.metaFrequencia,
      razaoSocial: this.state.pushLojas.nome,
      email: this.state.pushLojas.email,
      dddLoja: parseInt(this.state.pushLojas.dddLoja),
      telefoneLoja: parseInt(this.state.pushLojas.telefoneLoja),
      cep: this.state.pushLojas.cep,
      endereco: this.state.pushLojas.rua,
      Numeroendereco: parseInt(this.state.pushLojas.enderecoNumero),
      complemento: this.state.pushLojas.complemento,
      bairro: this.state.pushLojas.bairro,
      cidade: this.state.pushLojas.cidade,
      uf: this.state.pushLojas.estado,
      statusId: this.state.pushLojas.statusId,
      vendedorId: parseInt(this.state.pushLojas.vendedorId),
    };

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      body: JSON.stringify(dados),
      headers: myHeaders,
      redirect: "follow",
    };
    var AddLojas = await fetch(
      `${URLBunge}/api/Vendedores/Adicionaloja`,
      requestOptions
    ).then((response) => response.json());

    if (AddLojas.data.sucesso) {
      Swal.fire({
        icon: "success",
        title: "Tudo Certo!",
        text: "Loja Cadastrada com sucesso!",
      });
      let modalNumber = "modal4";
      this.setState({
        [modalNumber]: !this.state[modalNumber],
      });
      window.location.href = window.location.href;
    } else {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: AddLojas.data.mensagem,
      });
    }
    this.setState({ loading: false });
  };

  AtualizaLojas = async () => {
    this.setState({ loading: true });

    if (this.state.pushLojas.nome == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe a Razão Social",
      });
      this.setState({ loading: false });
      return;
    } else if (this.state.pushLojas.potencial == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o Potencial",
      });
      this.setState({ loading: false });
      return;
    } else if (this.state.pushLojas.faixa == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe a faixa",
      });
      this.setState({ loading: false });
      return;
    } else if (this.state.pushLojas.metaFrequencia == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe a Meta Frequencia",
      });
      this.setState({ loading: false });
      return;
    } else if (this.state.pushLojas.statusId == "") {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Informe o status",
      });
      this.setState({ loading: false });
      return;
    }

    var dados = {
      /*"idProjeto": getProjeto(),*/
      codigo: this.state.pushLojas.codigo,
      cnpj: this.state.pushLojas.cnpj,
      razaoSocial: this.state.pushLojas.nome,
      email: this.state.pushLojas.email,
      dddLoja: parseInt(this.state.pushLojas.dddLoja),
      telefoneLoja: parseInt(this.state.pushLojas.telefoneLoja),
      cep: this.state.pushLojas.cep,
      endereco: this.state.pushLojas.rua,
      Numeroendereco: parseInt(this.state.pushLojas.enderecoNumero),
      bairro: this.state.pushLojas.bairro,
      complemento: this.state.pushLojas.complemento,
      cidade: this.state.pushLojas.cidade,
      uf: this.state.pushLojas.estado,
      potencial: this.state.pushLojas.potencial,
      faixa: this.state.pushLojas.faixa,
      metaFrequencia: this.state.pushLojas.metaFrequencia,
      statusId: this.state.pushLojas.statusId,
      vendedorId: parseInt(this.state.pushLojas.vendedorId),
    };

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      body: JSON.stringify(dados),
      headers: myHeaders,
      redirect: "follow",
    };
    var retornoAtt = await fetch(
      `${URLBunge}/api/Vendedores/Atualizaloja`,
      requestOptions
    ).then((response) => response.json());

    if (retornoAtt.data.sucesso) {
      Swal.fire({
        icon: "success",
        title: "Tudo Certo!",
        text: "Cadastros/Edição Realizada com sucesso!",
      }).then(async (result) => {
        this.CarregaLojas(
          this.state.pushLojas.cnpj,
          this.state.pushLojas.codigo
        );
        let modalNumber = "modal4";
        this.setState({
          [modalNumber]: !this.state[modalNumber],
        });
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: retornoAtt.data.mensagem,
      });
    }

    this.setState({ loading: false });
  };

  AttAutomatica = async () => {
    this.setState({ att: true });
    this.CarregaLojas();
    var intervalId = setInterval(() => this.CarregaLojas(), 10000);
    this.setState({ intervalId: intervalId });
  };

  AttAutomaticaD = async () => {
    this.setState({ att: false });
    clearInterval(this.state.intervalId);
  };

  render() {
    return (
      <Container>
        {this.state.loading && <Carregando />}
        <HeaderPortalVendedor />
        <MenuPrinc />

        <HomeFornada>
          <div className="clear"></div>

          <div className="cadastros">
            <h1>Cadastro/Edição de Lojas </h1>

            <div id="filtros">
              {/* <MDBBtn color="success" size="sm" onClick={() => this.toggle(5)} style={{ float: 'right' }}>Cadastro via excel</MDBBtn> */}
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => this.toggle(4)}
                style={{ float: "right" }}
              >
                Cadastro Unitário
              </MDBBtn>

              <MDBRow>
                <MDBCol md="4">
                  <MDBInput
                    label="Informe o CNPJ"
                    outline
                    size="lg"
                    value={this.state.cnpj}
                    maxLength="14"
                    onChange={(e) => this.setState({ cnpj: e.target.value })}
                  />
                </MDBCol>

                <MDBCol md="4">
                  <MDBInput
                    label="Informe o código da Loja"
                    outline
                    size="lg"
                    value={this.state.codigo}
                    onChange={(e) => this.setState({ codigo: e.target.value })}
                  />
                </MDBCol>

                <MDBCol md="2">
                  <MDBBtn
                    data-test="button"
                    type="button"
                    color="primary"
                    onClick={() => this.CarregaLojas()}
                  >
                    Filtrar
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </div>

            <div class="tabresp">
              <MDBDataTable
                striped
                bordered
                hover
                searchLabel="Pesquisar"
                paginationLabel={["Anterior", "Próximo"]}
                noRecordsFoundLabel="Nenhum resultado encontrado"
                infoLabel={["Mostrando", "de", "até", "registros"]}
                entriesLabel="Qtd por pagina"
                style={{ textAlign: "center" }}
                data={this.state.DadosLoja}
              />
            </div>
          </div>

          <MDBModal
            isOpen={this.state.modal4}
            toggle={() => this.toggle(4)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(4)}>
              DADOS DA LOJA
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  {/* Código */}
                  <MDBCol md="4">
                    <MDBInput
                      label="Código"
                      outline
                      size="lg"
                      readOnly={this.state.pushLojas.Readonly}
                      value={this.state.pushLojas.codigo}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.codigo = parseInt(e.target.value);
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>

                  {/* CNPJ */}
                  <MDBCol md="8">
                    <InputMask
                      className="form-control form-control-lg"
                      mask="99.999.999/9999-99"
                      maskChar=""
                      label="CNPJ"
                      outline
                      size="lg"
                      type="text"
                      value={this.state.pushLojas.cnpj}
                      readOnly={this.state.pushLojas.Readonly}
                      placeholder="CNPJ"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.cnpj = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>

                  {/* Razão Social */}
                  <MDBCol md="12">
                    <MDBInput
                      label="Razão Social"
                      outline
                      size="lg"
                      value={this.state.pushLojas.nome}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.nome = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>

                  {/* Email da Loja" */}
                  <MDBCol md="12">
                    <MDBInput
                      label="Email da Loja"
                      value={this.state.pushLojas.email}
                      outline
                      size="lg"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.email = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>

                  {/*  DDD da loja */}
                  <MDBCol md="3">
                    <InputMask
                      className="form-control form-control-lg"
                      mask="99"
                      maskChar=""
                      type="text"
                      outline
                      size="lg"
                      label="DDD da loja"
                      value={this.state.pushLojas.dddLoja}
                      placeholder="DDD da loja"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.dddLoja = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                    {/* <MDBInput label="Telefone da loja" outline size="lg" value={this.state.telefoneLoja} onChange={e => this.setState({ telefoneLoja: e.target.value })}/> */}
                  </MDBCol>

                  {/*  Telefone da loja */}
                  <MDBCol md="9">
                    <InputMask
                      className="form-control form-control-lg"
                      mask="999999999"
                      maskChar=""
                      type="text"
                      outline
                      size="lg"
                      label="Telefone da loja"
                      value={this.state.pushLojas.telefoneLoja}
                      placeholder="Telefone da loja"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.telefoneLoja = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                    {/* <MDBInput label="Telefone da loja" outline size="lg" value={this.state.telefoneLoja} onChange={e => this.setState({ telefoneLoja: e.target.value })}/> */}
                  </MDBCol>

                  {/* Potencial */}
                  <MDBCol md="4">
                    <label>Potencial</label>
                    <select
                      className="browser-default custom-select"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.potencial = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    >
                      <option value="">Escolher</option>
                      <option
                        value="ALTO"
                        selected={
                          this.state.pushLojas.potencial == "ALTO"
                            ? "selected"
                            : ""
                        }
                      >
                        ALTO
                      </option>
                      <option
                        value="MÉDIO"
                        selected={
                          this.state.pushLojas.potencial == "MÉDIO"
                            ? "selected"
                            : ""
                        }
                      >
                        MÉDIO
                      </option>
                      <option
                        value="BAIXO"
                        selected={
                          this.state.pushLojas.potencial == "BAIXO"
                            ? "selected"
                            : ""
                        }
                      >
                        BAIXO
                      </option>
                    </select>
                  </MDBCol>

                  {/* FAIXA */}
                  <MDBCol md="4">
                    <label>FAIXA</label>
                    <select
                      className="browser-default custom-select"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.faixa = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    >
                      <option value="">Escolher</option>
                      <option
                        value="FAIXA 1 (0-4M)"
                        selected={
                          this.state.pushLojas.faixa == "FAIXA 1 (0-4M)"
                            ? "selected"
                            : ""
                        }
                      >
                        FAIXA 1 (0-4M)
                      </option>
                      <option
                        value="FAIXA 2 (5-8M)"
                        selected={
                          this.state.pushLojas.faixa == "FAIXA 2 (5-8M)"
                            ? "selected"
                            : ""
                        }
                      >
                        FAIXA 2 (5-8M)
                      </option>
                      <option
                        value="FAIXA 3 (9-12M)"
                        selected={
                          this.state.pushLojas.faixa == "FAIXA 3 (9-12M)"
                            ? "selected"
                            : ""
                        }
                      >
                        FAIXA 3 (9-12M)
                      </option>
                    </select>
                  </MDBCol>

                  {/* META FREQUENCIA */}
                  <MDBCol md="4">
                    <label>META FREQUENCIA</label>
                    <select
                      className={
                        "browser-default custom-select " + this.state.disabled
                      }
                      disabled={this.state.disabled}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.metaFrequencia = parseInt(e.target.value);
                        this.setState({ pushLojas: FornTrans });
                      }}
                    >
                      <option value="">Escolher</option>
                      <option
                        value={1}
                        selected={
                          this.state.pushLojas.metaFrequencia == 1
                            ? "selected"
                            : ""
                        }
                      >
                        1
                      </option>
                      <option
                        value={2}
                        selected={
                          this.state.pushLojas.metaFrequencia == 2
                            ? "selected"
                            : ""
                        }
                      >
                        2
                      </option>
                      <option
                        value={3}
                        selected={
                          this.state.pushLojas.metaFrequencia == 3
                            ? "selected"
                            : ""
                        }
                      >
                        3
                      </option>
                      <option
                        value={4}
                        selected={
                          this.state.pushLojas.metaFrequencia == 4
                            ? "selected"
                            : ""
                        }
                      >
                        4
                      </option>
                      <option
                        value={5}
                        selected={
                          this.state.pushLojas.metaFrequencia == 5
                            ? "selected"
                            : ""
                        }
                      >
                        5
                      </option>
                      <option
                        value={6}
                        selected={
                          this.state.pushLojas.metaFrequencia == 6
                            ? "selected"
                            : ""
                        }
                      >
                        6
                      </option>
                      <option
                        value={7}
                        selected={
                          this.state.pushLojas.metaFrequencia == 7
                            ? "selected"
                            : ""
                        }
                      >
                        7
                      </option>
                      <option
                        value={8}
                        selected={
                          this.state.pushLojas.metaFrequencia == 8
                            ? "selected"
                            : ""
                        }
                      >
                        8
                      </option>
                      <option
                        value={9}
                        selected={
                          this.state.pushLojas.metaFrequencia == 9
                            ? "selected"
                            : ""
                        }
                      >
                        9
                      </option>
                      <option
                        value={10}
                        selected={
                          this.state.pushLojas.metaFrequencia == 10
                            ? "selected"
                            : ""
                        }
                      >
                        10
                      </option>
                      <option
                        value={11}
                        selected={
                          this.state.pushLojas.metaFrequencia == 11
                            ? "selected"
                            : ""
                        }
                      >
                        11
                      </option>
                      <option
                        value={12}
                        selected={
                          this.state.pushLojas.metaFrequencia == 12
                            ? "selected"
                            : ""
                        }
                      >
                        12
                      </option>
                    </select>
                  </MDBCol>

                  <MDBCol md="5">
                    <label>Status</label>
                    <select
                      className="browser-default custom-select"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.statusId = parseInt(e.target.value);
                        this.setState({ pushLojas: FornTrans });
                      }}
                    >
                      <option value={0}>Escolher</option>
                      <option
                        value={22076}
                        selected={
                          this.state.pushLojas.statusId == 22076
                            ? "selected"
                            : ""
                        }
                      >
                        Loja Ativa
                      </option>
                      <option
                        value={22077}
                        selected={
                          this.state.pushLojas.statusId == 22077
                            ? "selected"
                            : ""
                        }
                      >
                        Bloqueado Bunge
                      </option>
                      <option
                        value={22078}
                        selected={
                          this.state.pushLojas.statusId == 22078
                            ? "selected"
                            : ""
                        }
                      >
                        Bloqueado Bunge - não apto financeiro
                      </option>
                    </select>
                  </MDBCol>

                  <MDBCol md="4">
                    <label>Vendedor Responsavel</label>
                    <select
                      className="browser-default custom-select"
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.vendedorId = parseInt(e.target.value);
                        this.setState({ pushLojas: FornTrans });
                      }}
                    >
                      <option
                        value="0"
                        selected={
                          this.state.pushLojas.vendedorId == "0"
                            ? "selected"
                            : ""
                        }
                      >
                        Escolher
                      </option>
                      {this.state.vendedoresTotal.map((vend, i) => {
                        return (
                          <option
                            value={vend.id}
                            key={i}
                            selected={
                              this.state.pushLojas.vendedorId == vend.id
                                ? "selected"
                                : ""
                            }
                          >
                            {vend.nome}
                          </option>
                        );
                      })}
                    </select>
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <div className="clear"></div> <br />
                  <MDBCol md="12" className="sep">
                    <span className="blockquote bq-title bq-warning">
                      Endereço da Loja
                    </span>
                  </MDBCol>
                  <div className="clear"></div> <br />
                  <MDBCol md="6">
                    <MDBInput
                      label="cep"
                      outline
                      size="lg"
                      value={this.state.pushLojas.cep}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.cep = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>
                  <MDBCol md="9">
                    <MDBInput
                      label="Endereço"
                      outline
                      size="lg"
                      value={this.state.pushLojas.rua}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.rua = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>
                  <MDBCol md="3">
                    <MDBInput
                      label="Nº"
                      outline
                      size="lg"
                      value={this.state.pushLojas.enderecoNumero}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.enderecoNumero = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="Compl"
                      outline
                      size="lg"
                      value={this.state.pushLojas.complemento}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.complemento = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="Bairro"
                      outline
                      size="lg"
                      value={this.state.pushLojas.bairro}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.bairro = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="Cidade"
                      outline
                      size="lg"
                      value={this.state.pushLojas.cidade}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.cidade = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>
                  <MDBCol md="4">
                    <MDBInput
                      label="UF"
                      outline
                      size="lg"
                      maxLength="2"
                      value={this.state.pushLojas.estado}
                      onChange={(e) => {
                        var FornTrans = this.state.pushLojas;
                        FornTrans.estado = e.target.value;
                        this.setState({ pushLojas: FornTrans });
                      }}
                    />
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              {this.state.pushLojas.id != null ? (
                <MDBBtn
                  color="primary"
                  size="sm"
                  onClick={() => this.AtualizaLojas()}
                >
                  Atualizar
                </MDBBtn>
              ) : (
                <MDBBtn
                  color="primary"
                  size="sm"
                  onClick={() => this.CadastrarLojas()}
                >
                  Cadastrar
                </MDBBtn>
              )}
            </MDBModalFooter>
          </MDBModal>

          <MDBModal
            isOpen={this.state.modal5}
            toggle={() => this.toggle(5)}
            size="md"
          >
            <MDBModalHeader toggle={() => this.toggle(5)}>
              Cadastro via Excel
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft" id="ArquivoInput">
                <MDBRow>
                  <MDBCol md="12">
                    <MDBCol md="12" style={{ float: "left" }}>
                      <label>Upload do Mailing</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span
                            className="input-group-text"
                            id="inputGroupFileAddon01"
                          >
                            Upload
                          </span>
                        </div>
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="ImagemFile"
                            aria-describedby="inputGroupFileAddon01"
                            accept="xls/*"
                            onChange={(e) => {
                              MudaVisibilidade("UpLoading");
                              this.LeArquivo(e);
                            }}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="ImagemFile"
                          >
                            Arquivo do Excel
                          </label>
                        </div>
                      </div>
                      <small> Extensão .xlsx</small>
                    </MDBCol>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
          </MDBModal>
        </HomeFornada>
      </Container>
    );
  }
}

export default withRouter(VendedorLojas);
